var getLocationOrigin = function getLocationOrigin() {
  return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
};

var companyName = '悟空CRM';
var version = 'V11.1.1';
var baiduKey = '百度key';

export default {
  version: version,
  companyName: companyName,
  getLocationOrigin: getLocationOrigin,
  baiduKey: baiduKey
};